import React from 'react';
import { CircularProgress } from '@material-ui/core';
import styles from './loader.module.scss';

const Loader = ({ size = 40, className = 'primary' }) => (
  <CircularProgress classes={{ root: styles.loader, svg: styles[className] }} size={size}/>
);

export default Loader;
